import { createContext } from "react";
import { PostList } from "src/api/client-api/post/types/postList.types";
import { Product } from "src/api/client-api/products/useGetOneProduct";
import { ProductReference } from "src/api/sure-api/productReference/useGetOneProductReference";
import { SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";
import { Post } from "src/api/client-api/post/postSchema";
import { OlapScoresWithPrevScores } from "src/api/client-api/olapScores/olapScoresSchema";
import type { useGetProductScores } from "src/api/client-api/olapScores/useGetProductScores";

type ProductScoresQueryResult = ReturnType<typeof useGetProductScores>;

export type ProductMetadataContextInitialValues = {
    product: Product;
    productReference: ProductReference | undefined;

    ssqVersion: SsqVersion | undefined;
    isSsqVersionReady: boolean;

    scores: OlapScoresWithPrevScores | undefined;
    areScoresRefetching: boolean;
    scoreQueryError: ProductScoresQueryResult["error"];
    isScoreQueryError: ProductScoresQueryResult["isError"];
    retryScoreQuery: ProductScoresQueryResult["refetch"];

    activeCompanyId: number | undefined;

    productPosts: PostList[] | undefined;

    activePost: Post | undefined;
    isActivePostRefetching: boolean;
    isActivePostLoading: boolean;

    canModifySSQ: boolean;
    areProductCompaniesVisible: boolean;
};

export const ProductMetadataContext = createContext<ProductMetadataContextInitialValues | null>(null);
